import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type {
  ReportConfiguration,
  ReportConfigurationId,
  ReportConfigurationInitializer,
  ReportConfigurationMutator,
  ProjectId,
  ReportTemplateId,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/report-configuration'

// Get all configs for a project
export const getByProject = (
  projectId: ProjectId,
  options: AxiosRequestConfig = {},
): Promise<{ configs: ReportConfiguration[] }> =>
  apiUtils.GET(`${url}/by-project/${projectId}`, options)

// Get config for a specific project + template
export const getForProjectAndTemplate = (
  projectId: ProjectId,
  templateId: ReportTemplateId,
  options: AxiosRequestConfig = {},
): Promise<{ config: ReportConfiguration | null }> =>
  apiUtils.GET(`${url}/`, merge({ params: { projectId, templateId } }, options))

// Get by ID
export const get = (
  id: ReportConfigurationId,
  options: AxiosRequestConfig = {},
): Promise<{ config: ReportConfiguration }> =>
  apiUtils.GET(`${url}/${id}`, options)

// Create new configuration
export const create = (data: ReportConfigurationInitializer) =>
  apiUtils.POST(`${url}/`, data)

// Update by ID
export const update = (
  id: ReportConfigurationId,
  data: ReportConfigurationMutator,
) => apiUtils.PUT(`${url}/${id}`, data)

// Delete
export const remove = (id: ReportConfigurationId) =>
  apiUtils.DELETE(`${url}/${id}`)
